module.exports = __webpack_public_path__ + "static/PicInt-c6794479103e502e8eec68519d108c27.jpg";